module.exports = __webpack_public_path__ + "img/icon-next.d2eff69a.svg";